import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';

export interface BudgetSimulationDto {
  id: string;
  year: number;
  personalBudgetMax?: number | null;
  selectedForecastLineIds: string[];
  selectedProjectIds: string[];
}

export interface UpsertBudgetSimulationDto {
  year: number;
  personalBudgetMax?: number;
  selectedForecastLineIds: string[];
  selectedProjectIds: string[];
}

export class BudgetSimulationApi {
  private axiosInstance: AxiosInstance;

  constructor(configuration: Configuration) {
    this.axiosInstance = axios.create({
      baseURL: configuration.basePath ?? '',
      ...configuration.baseOptions,
    });
  }

  async getSimulation(assetId: string, year: number): Promise<BudgetSimulationDto | null> {
    const response = await this.axiosInstance.get<BudgetSimulationDto | null>(
      `/assets/${assetId}/budget-simulation`,
      { params: { year } }
    );
    return response.data;
  }

  async upsertSimulation(
    assetId: string,
    dto: UpsertBudgetSimulationDto
  ): Promise<BudgetSimulationDto> {
    const response = await this.axiosInstance.put<BudgetSimulationDto>(
      `/assets/${assetId}/budget-simulation`,
      dto
    );
    return response.data;
  }
}
